import { render, staticRenderFns } from "./ExamTypesDetails.vue?vue&type=template&id=17b516c2"
import script from "./ExamTypesDetails.vue?vue&type=script&lang=js"
export * from "./ExamTypesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports